import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 7.02c0 3.877-3.582 7.02-8 7.02a9.04 9.04 0 0 1-2.304-.295L0 16l1.395-5.018C.515 9.854 0 8.49 0 7.02 0 3.143 3.582 0 8 0s8 3.143 8 7.02ZM4.293 6.31a.998.998 0 0 1 1.414 0c.39.393.39 1.028 0 1.42a.998.998 0 0 1-1.414 0 1.005 1.005 0 0 1 0-1.42Zm6 1.42a.998.998 0 0 0 1.414 0c.39-.392.39-1.027 0-1.42a.998.998 0 0 0-1.414 0 1.005 1.005 0 0 0 0 1.42Zm-1.586 0c.39-.392.39-1.027 0-1.42a.998.998 0 0 0-1.414 0 1.005 1.005 0 0 0 0 1.42.998.998 0 0 0 1.414 0Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconCommunicationMessage16 = createIcon(IconComponent);